import Rebase from 're-base';

import env from './env';

const rebase = Rebase.createClass(getConfig());

// rebase.onAuth(user => {
//   console.log('onAuth: ', user);
//
//   if (!user) {
//     // rebase.authWithOAuthPopup('google', authHandler);
//     rebase.authWithOAuthRedirect('google', authHandler);
//   }
// });

rebase.authGetOAuthRedirectResult((error, authData) => {
  // console.log('rebase.authGetOAuthRedirectResult', error, authData);

  if (error) {
    console.error('rebase.authGetOAuthRedirectResult', error);
  }

  if(authData.user) {
    // doSomethingWithAuthenticatedUser(authData.user);
  } else {
    //redirect to twitter for auth
    // base.authWithOAuthRedirect('twitter', authHandler);
  }
});

export default rebase;

function getConfig() {
  if (env.production) {
    return {
      apiKey: 'AIzaSyC93aaEj5PEj9oL3bdEuNmtJKwqz3dM0Do', // needed for auth
      authDomain: 'reshop-3ad21.firebaseapp.com',        // needed for OAuth
      databaseURL: 'https://reshop-3ad21.firebaseio.com'
      // storageBucket: 'reshop-3ad21.appspot.com',
      // messagingSenderId: '974288775225'
    };
  } else {
    return {
      apiKey: "AIzaSyAaftFfODjPN-o-Y3YSA9rsagn0wi1cLws",
      authDomain: "reshop-dev.firebaseapp.com",
      databaseURL: "https://reshop-dev.firebaseio.com"
      // storageBucket: "reshop-dev.appspot.com",
      // messagingSenderId: "1008780239200"
    };
  }
}

// function authHandler(error, data) {
//   if (error) {
//     console.log('error: ', error);
//   }
//
//   console.log('data: ', data);
// }


// rebase.authWithPassword({
//   email    : 'bobtony@firebase.com',
//   password : 'notapassword'
// }, authHandler);


// Example firebase code
// import firebase from 'firebase';
// firebase.initializeApp({ databaseURL: 'https://reshop-3ad21.firebaseio.com' });
// const database = firebase.database();
// const ref = database.ref('/lists');
// // ref.on('value', snapshot => { debugger; console.log(snapshot); });
// ref.on('child_added', data => { console.log(data); });



/** WEBPACK FOOTER **
 ** ./src/rebase.js
 **/